import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Header from "./components/header";
import useShowJSD from "../../hooks/useShowJSD";
import LanguageSwitcher from "../../components/LanguageSwitcher";

function PublicLayout({
  children,
}: {
  children?: React.ReactNode;
}): React.JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useShowJSD({ isAuth: false });
  const { t } = useTranslation();

  return (
    <>
      {isMobile ? <Header /> : null}
      <Grid container justifyContent="center" sx={{ minHeight: "100vh" }}>
        {!isMobile ? (
          <Grid p={8} sx={{ bgcolor: "primary.main" }} size={6}>
            <Stack
              alignItems="center"
              height="100%"
              justifyContent="space-between"
            >
              <Box />
              <Stack alignItems="center" gap="64px">
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    gap: 1,
                  }}
                >
                  <Link to="/login">
                    <img
                      alt="logo"
                      height="200px"
                      src="/assets/logo.png"
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "200px",
                        maxWidth: "397px",
                      }}
                    />
                  </Link>
                </Box>
                <Typography
                  color="common.white"
                  fontFamily="Inter"
                  fontSize="48px"
                  fontWeight={400}
                  textAlign="center"
                  variant="h3"
                >
                  {window.constants?.titleLogo || t("common.portalDeServicos")}
                </Typography>
              </Stack>
              <Box sx={{ maxWidth: "130px", width: "100%" }}>
                <img
                  alt="smartdocs"
                  src="/assets/smartdocs-branco.png"
                  style={{
                    width: "100%",
                    height: "auto",
                  }}
                  width="100%"
                />
              </Box>
            </Stack>
          </Grid>
        ) : null}
        <Grid p={isMobile ? 3 : 8} size={{ sm: 6, xs: 12 }}>
          {!isMobile && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
              <LanguageSwitcher />
            </Box>
          )}
          <Stack alignItems="center" height="100%">
            <Box height="100%" maxWidth="532px" width="100%">
              {children ?? <Outlet />}
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default PublicLayout;
